import { Injectable, signal } from '@angular/core';

/**
 * Tracks the browser's network connectivity using the online/offline events.
 *
 * Note: `navigator.onLine` only reflects whether the device has a network
 * interface, not whether the internet is actually reachable. Request-level
 * failures (e.g. the server being unreachable) are surfaced separately by the
 * error interceptor handling `status === 0`.
 */
@Injectable({ providedIn: 'root' })
export class ConnectivityService {
  /** `true` when the browser reports an active network connection. */
  readonly isOnline = signal(navigator.onLine);

  constructor() {
    window.addEventListener('online', () => this.isOnline.set(true));
    window.addEventListener('offline', () => this.isOnline.set(false));
  }
}
